import React, { useState } from "react";
import { Link } from "react-router-dom";
import '../../scss/pages/_phoneotp.scss';
// image
import logo from "../../images/fhub_icon.png";
import { useHistory } from 'react-router-dom';
import { connect, useDispatch } from 'react-redux';

import {
    loadingToggleAction,
    forgotPasswordAction,
} from '../../store/actions/AuthActions';



const PhoneOtp = (props) => {

    const [otp, setOtp] = useState();



    const dispatch = useDispatch();


    function onLogin(e) {
        e.preventDefault();
        dispatch(loadingToggleAction(true));
        dispatch(forgotPasswordAction(otp, props.history));
    }

    const history = useHistory();

    return (
        <div className="otp">
            <div className="card  mx-auto  login-card">
                <div className="card-body">
                    <div className="row" style={{ position: 'relative' }}>
                        <img className='img-fluid logo-img' src={logo} />
                        <p className="text-center forgotp">Please enter your OTP</p>
                        <p className=" text-center no-prbp fs-5">No problem! Just provide your OTP and we'll send you a new password box.</p>

                        <form onSubmit={onLogin}>
                            <div className="form-group mb-3 mt-3 focus">
                                <input type="number" className="form-control"
                                    value={otp} onChange={(e) => setOtp(e.target.value)}
                                />
                                <label className="mb-2 "><strong>OTP</strong>  </label>
                            </div>

                            <button type="submit" className={otp ? "forget-text d-flex justify-content-center fs-4 mt-4" : "forget-text-disable  d-flex justify-content-center fs-4 mt-4"} style={{ cursor: 'pointer' }}> <b> Send</b> </button>

                            <Link onClick={() => history.push("/login")} className="forget-text d-flex justify-content-center fs-4 mt-2" style={{ cursor: 'pointer' }}> <b> Back</b> </Link>
                        </form>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default PhoneOtp;
